import jwtAxios from '../../@crema/services/auth/jwt-auth/jwt-api';
import {fetchError, fetchStart, fetchSuccess} from './Common';
import {AppActions} from '../../types';
import {Dispatch} from 'redux';
import { UPDATE_DOCUMENT_LIST } from '../../types/actions/Document.action';

export const onRequestDocuments = (body: {
  pageNumber: number;
  pageSize: number;
}) => {
  return async (dispatch: Dispatch<AppActions>) => {
    dispatch(fetchStart());
    try {
      const res = await jwtAxios.get('Documents?pageNumber='+body.pageNumber+"&pageSize="+body.pageSize);     
      dispatch(fetchSuccess());
      dispatch({
        type: UPDATE_DOCUMENT_LIST,
        payload: res.data.result,
      });
    } catch (err) {
      console.log('error!!!!', err.response);
      dispatch(fetchError(err.response));
    }
  };
};

